import { createSelector } from 'reselect';

import type { State } from 'reducers';

import { initialState } from './reducer';
import type { CreateEmployeeFormPageState } from './reducer';

const selectState = (state: State): CreateEmployeeFormPageState =>
  state.get('CreateEmployeeFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
